module.exports = __webpack_public_path__ + "img/14.70369d21.jpg";